import script from "./cardDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./cardDetail.vue?vue&type=script&setup=true&lang=js"

import "./cardDetail.vue?vue&type=style&index=0&id=66550608&scoped=true&lang=css"
import "./cardDetail.vue?vue&type=style&index=1&id=66550608&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66550608"]])

export default __exports__